import React from 'react'
import { appConfig } from 'util/core/config/app-config.instance'

interface ExternalLinkProps {
  className?: string
  title?: string
  href?: string
  children: any
  oldDzo?: boolean
  auctions?: boolean
  prozorroApi?: boolean
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

export const ExternalLink: React.FC<ExternalLinkProps> = ({ className, href, title, children, oldDzo, auctions, prozorroApi, onClick }) => {
  const prozorroLink = appConfig.get('PROZORRO')
  const oldDzoLink = appConfig.get('OLD_DZO')
  const prozorroApiLink = appConfig.get('PROZORRO_API_LINK')

  const link = oldDzo ? oldDzoLink : auctions ? '' : prozorroApi ? prozorroApiLink : prozorroLink

  return (
    <a
      className={className}
      href={`${link}${href ?? ''}`}
      title={title ?? 'Prozorro'}
      target={oldDzo ? '' : '_blank'}
      rel="noopener noreferrer nofollow"
      onClick={onClick}
    >
      {children}
    </a>
  )
}
